/** @format */

import * as R from 'ramda';

import {CompanyFromQuery} from '../types';

const filterCompaniesBySearchString = (
  companies: ReadonlyArray<CompanyFromQuery>,
  search: string,
): ReadonlyArray<CompanyFromQuery> => {
  const lowerCaseSearch = search.toLowerCase().trim();
  return R.pipe(
    R.filter(
      (v: CompanyFromQuery) => search === '' || v.name.toLowerCase().indexOf(lowerCaseSearch) >= 0,
    ),
    R.sortBy(v => v.name),
  )(companies);
};

export {filterCompaniesBySearchString};
